import type { FormatFilter, SortOption } from "@/routes/_app/artist/$id/artist-discography";
import type { DiscographyQueryType } from "@/types/discography";
import { client, orpc } from "@/utils/orpc.client";

const PAGE_SIZE = 48;

interface CompanyAlbumsQueryOptionsInput {
  companyId: string;
  discographyQueryType: DiscographyQueryType;
  filter?: unknown[];
  format: FormatFilter;
  sort: SortOption;
  search?: string;
}

export function getCompanyAlbumsInfiniteQueryOptions(input: CompanyAlbumsQueryOptionsInput) {
  const albumsInput = (pageParam: number) => getCompanyAlbumsInput(input, pageParam);

  return {
    queryKey: orpc.music.getCompanyAlbums.infiniteKey({
      input: albumsInput,
      initialPageParam: 0,
    }),
    queryFn: ({ pageParam }: { pageParam: unknown }) =>
      client.music.getCompanyAlbums(albumsInput(pageParam as number)),
    initialPageParam: 0,
    getNextPageParam: (
      lastPage: { hasMore: boolean },
      _allPages: unknown,
      lastPageParam: number,
    ) => {
      if (!lastPage.hasMore) return undefined;
      return lastPageParam + PAGE_SIZE;
    },
  };
}

function getCompanyAlbumsInput(input: CompanyAlbumsQueryOptionsInput, pageParam: number) {
  return {
    id: input.companyId,
    type: input.discographyQueryType,
    format: input.format,
    filter: input.filter?.length ? input.filter : undefined,
    sort: input.sort,
    search: input.search || undefined,
    includeFacets: pageParam === 0,
    limit: PAGE_SIZE,
    offset: pageParam,
  };
}
